import { industryFilter } from '../../../store/features/projects/selectors';
import { useGetProjectsQuery } from '../../../store/features/projects/service';
import Button from '../../UI/Button';

interface IIndustryFilter {
  selected: string[];
  onSelect(industry: string): void;
}
export default function IndustryFilter({ selected, onSelect }: IIndustryFilter) {
  const { data: list } = useGetProjectsQuery('', {
    selectFromResult: (response) => ({
      ...response,
      data: industryFilter(response.data || []),
    }),
  });

  return (
    <div className="d-flex justify-content-between align-items-center mt-2">
      Industry:
      <div className="d-flex justify-content-end flex-wrap">
        {list?.map((name: string) => {
          const isSelected = selected.includes(name);
          return (
            <Button
              variant={isSelected ? 'secondary' : 'outline-secondary'}
              size="sm"
              onClick={() => onSelect(name)}
              key={name}
            >
              {name}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
